<template>
  <div class="task-manage-container">
    <star-condition-layout
      :onSearch="handleSearch"
      :onReset="reset"
      :loading="loading"
      ref="condition"
    >
      <star-condition-cell label="服务地址">
        <a-input v-model="search.servers"></a-input>
      </star-condition-cell>
      <star-condition-cell label="状态">
        <a-select allowClear style="width: 100%" v-model="search.status">
          <a-select-option :value="0">未启用</a-select-option>
          <a-select-option :value="-1">停用</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="站点类型">
        <a-select allowClear v-model="search.spiderClassId" style="width: 100%">
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.spiderClassId"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>
    </star-condition-layout>
    <a-button class="add-btn" @click="openDialog" type="primary">新增</a-button>

    <div class="table-container">
      <TableHeadIcons :onRefresh="getList" :size.sync="tableDensity" :columns="columns" />
      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :rowKey="(record) => record.spiderMqId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="action" slot-scope="text, record">
          <a-button @click="editSpiderMq(record)" type="link">修改</a-button>
          <a-divider type="vertical"></a-divider>
          <a-popconfirm title="确定要删除吗?" @confirm="() => deleteSpiderMq(record)">
            <a-button type="link">删除</a-button>
          </a-popconfirm>
          <a-divider type="vertical"></a-divider>
          <a-button @click="showDetail(record)" type="link">详情</a-button>
          <a-divider type="vertical"></a-divider>
          <a-button @click="changeStatus(record)" type="link">{{
            record.status !== 1 ? '启用' : '停用'
          }}</a-button>
        </span>
      </a-table>
    </div>

    <a-modal :footer="null" title="IP池详情" :visible="detailFlag" @cancel="detailFlag = false">
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <!-- <a-form-model-item label="id">{{ detail.spiderMqId }}</a-form-model-item> -->
        <a-form-model-item label="消息队列类型">{{ detail.mqType }}</a-form-model-item>
        <a-form-model-item label="站点类型">{{ detail.spiderClassName }}</a-form-model-item>
        <a-form-model-item label="服务地址">{{ detail.servers }}</a-form-model-item>
        <a-form-model-item label="内容队列名称">{{ detail.contentQueueName }}</a-form-model-item>
        <a-form-model-item label="外链队列名称">{{
          detail.externalUrlQueueName
        }}</a-form-model-item>
        <a-form-model-item label="文件队列名称">{{ detail.fileQueueName }}</a-form-model-item>
        <a-form-model-item label="状态">{{ detail.statusName }}</a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      :footer="null"
      :title="`${form.spiderMqId ? '编辑' : '新增'}`"
      :visible="addFlag"
      @cancel="handleCancle"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item prop="mqType" label="消息队列类型">
          <a-radio-group v-model="form.mqType">
            <a-radio value="kafka">kafka</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item prop="spiderClassId" label="站点类型">
          <a-select allowClear v-model="form.spiderClassId">
            <a-select-option
              v-for="item in spiderClassOptions"
              :key="item.spiderClassId"
              :value="item.spiderClassId"
              >{{ item.spiderClassName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="servers" label="服务地址">
          <a-input placeholder="请输入服务地址，多个以”，“隔开" v-model="form.servers"></a-input>
        </a-form-model-item>

        <a-form-model-item prop="contentQueueName" label="内容队列名称">
          <a-input v-model="form.contentQueueName" />
        </a-form-model-item>

        <a-form-model-item prop="externalUrlQueueName" label="外链队列名称">
          <a-input v-model="form.externalUrlQueueName" />
        </a-form-model-item>
        <a-form-model-item prop="fileQueueName" label="文件队列名称">
          <a-input v-model="form.fileQueueName" />
        </a-form-model-item>

        <p style="text-align: right">
          <a-button type="primary" @click="onSubmit">提交</a-button>
          <a-button style="margin-left: 10px" @click="handleCancle">取消</a-button>
        </p>
      </a-form-model>
    </a-modal>

    <a-modal :footer="null" v-model="statusFlag" title="IP池替换">
      <p>选择替换的IP池:</p>
      <a-select v-model="replaceMqId" style="width: 100%">
        <a-select-option
          clearable
          v-for="item in replaceIpPoolList"
          :key="item.spiderMqId"
          :value="item.spiderMqId"
          >{{ item.servers }}
        </a-select-option>
      </a-select>

      <p style="text-align: right; margin-top: 15px">
        <a-button type="primary" :disabled="!this.replaceMqId" @click="onReplaceStatus">提交</a-button>
        <a-button style="margin-left: 10px" @click="statusFlag = false">取消</a-button>
      </p>
    </a-modal>
  </div>
</template>

<script>
import {
  getSpiderMqList,
  addSpiderMq,
  editSpiderMq,
  deleteSpiderMq,
  editSpiderMqStatus
} from '@/api/System/MqConfig'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import TableHeadIcons from '@/components/TableHeadIcons'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'

export default {
  components: { TableHeadIcons },
  mixins: [tableSettingToStoreMixin()],
  data() {
    return {
      search: {
        servers: undefined,
        status: undefined,
        spiderClassId: undefined
      },
      tableDensity: 'middle',
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      tableData: [],
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassName',
          align: 'center',
          show: true
        },
        {
          title: '消息队列类型',
          dataIndex: 'mqType',
          align: 'center',
          show: true
        },
        {
          title: '服务地址',
          dataIndex: 'servers',
          align: 'center',
          show: true
        },
        {
          title: '内容队列名称',
          dataIndex: 'contentQueueName',
          align: 'center',
          show: true
        },
        {
          title: '外链队列名称',
          dataIndex: 'externalUrlQueueName',
          align: 'center',
          show: true
        },
        {
          title: '文件队列名称',
          dataIndex: 'fileQueueName',
          align: 'center',
          show: true
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          show: true,
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'taskCreateTime' },
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 280,
          align: 'center'
        }
      ],
      loading: false,
      spiderClassOptions: [],
      addFlag: false,
      selectList: [],
      form: {
        mqType: undefined,
        servers: undefined,
        spiderClassId: undefined,
        contentQueueName: 'spider_content_prod_queue_all',
        externalUrlQueueName: 'spider_external_url_queue',
        fileQueueName: 'spider_file_queue'
      },
      rules: {
        mqType: [{ required: true, message: '消息队列类型不能为空', trigger: 'change' }],
        servers: [{ required: true, message: '服务地址不能为空', trigger: 'blur' }],
        contentQueueName: [{ required: true, message: '内容队列名称能为空', trigger: 'change' }],
        externalUrlQueueName: [
          { required: true, message: '外链队列名称不能为空', trigger: 'change' }
        ],
        fileQueueName: [{ required: true, message: '文件队列名称不能为空', trigger: 'change' }],
        spiderClassId: [{ required: true, message: '站点类型不能为空', trigger: 'change' }]
      },
      detailFlag: false,
      detail: {},
      statusFlag: false,
      replaceMqId: '',
      changeStatusItem: {},
      replaceIpPoolList: []
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  created() {
    this.getList()
    this.querySpiderClassInfo()
  },
  methods: {
    async querySpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data
      } else {
        this.$message.error(msg)
      }
    },
    showDetail(item) {
      this.detail = item
      this.detailFlag = true
    },
    handleCancle() {
      this.$refs.form.resetFields()
      this.addFlag = false
      this.form.spiderMqId = undefined
    },
    openDialog() {
      this.addFlag = true
      if (this.selectList.length === 0) {
        this.querySpiderClassInfoApi()
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.spiderMqId) {
            //这里是编辑
            editSpiderMq(this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success('编辑成功')
                  this.getList()
                } else {
                  this.$message.error(res.msg)
                }
              })
              .finally(() => {
                this.handleCancle()
              })
          } else {
            // 这里是新增
            addSpiderMq(this.form)
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success('新增成功')
                  this.getList()
                } else {
                  this.$message.error(res.msg)
                }
              })
              .finally(() => {
                this.handleCancle()
              })
          }
        } else {
          this.$message.error('请完善表单')
          return false
        }
      })
    },

    editSpiderMq(item) {
      this.form = Object.assign({}, item)
      this.openDialog()
    },
    async querySpiderClassInfoApi() {
      const { code, data } = await querySpiderClassInfoApi()
      if (code === 200) {
        this.selectList = data
      }
    },
    async getList() {
      this.loading = true
      let { code, data, extra } = await getSpiderMqList({
        ...this.search,
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize
      })
      this.loading = false
      if (code === 200) {
        this.tableData = data
        this.pagination.total = extra.page.pageCount || 0
      }
    },
    handleTableChange(pagination) {
      this.pagination = pagination
      this.getList()
    },

    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },

    reset() {
      this.search.servers = ''
      this.search.status = ''
      this.getList()
    },

    deleteSpiderMq(item) {
      deleteSpiderMq({ spiderMqId: item.spiderMqId }).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onReplaceStatus() {
      let tempv = this.replaceMqId
      this.replaceMqId = ''
      editSpiderMqStatus({
        spiderMqId: this.changeStatusItem.spiderMqId,
        status: -1,
        replaceMqId: tempv
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('替换成功')
            this.getList()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.replaceMqId = ''
          this.statusFlag = false
        })
    },
    async changeStatus(record) {
      // 1未启用状态
      if (record.status !== 1) {
        this.$confirm({
          title: '确认开启',
          content: '确认启用此配置?',
          autoFocusButton: 'ok',
          okText: '确定',
          onOk: () => {
            editSpiderMqStatus({ spiderMqId: record.spiderMqId, status: 1 }).then((res) => {
              if (res.code === 200) {
                this.$message.success('启用成功')
                this.getList()
              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      } else {
        this.changeStatusItem = record
        const { code, data } = await getSpiderMqList()
        if (code === 200) {
          this.replaceIpPoolList = data.filter((item) => {
            return (
              record.spiderMqId !== item.spiderMqId &&
              record.spiderClassId === item.spiderClassId &&
              record.mqType === item.mqType
            )
          })
        }
        this.statusFlag = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.task-manage-container {
  width: 100%;
  padding: 16px;
  position: relative;

  .table-container {
    background-color: white;
    padding: 0 16px;
    margin-top: 16px;
  }
  .add-btn {
    position: absolute;
    right: 180px;
    top: 32px;
  }
}
</style>
